import i18n from "@/plugins/i18n"

/**
 * Статусы почтовых уведомлений. Должны совпадать со статусами из MailLog.php
 */
export enum MailStatus {
    CREATED = 1,
    RETRY = 2,
    SENT = 3,
    FAILED = 4,
}

const statusTexts = {
    [MailStatus.CREATED]: 'Создано',
    [MailStatus.RETRY]: 'Отправка',
    [MailStatus.SENT]: 'Отправлено',
    [MailStatus.FAILED]: 'Ошибка',
};

/**
 * Возвращает текстовое описание статуса почтового уведомления по его коду.
 */
export function getMailStatusTextByCode(status: number): string {
    return i18n.global.t(statusTexts[status]);
}
